/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Automation_TemplatesInputs */

const cs_settings_automation_templates = /** @type {(inputs: Settings_Automation_TemplatesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Začít ze šablony`)
};

const en_settings_automation_templates = /** @type {(inputs: Settings_Automation_TemplatesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Start from a template`)
};

/**
* | output |
* | --- |
* | "Start from a template" |
*
* @param {Settings_Automation_TemplatesInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const settings_automation_templates = /** @type {((inputs?: Settings_Automation_TemplatesInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Automation_TemplatesInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_automation_templates(inputs)
	return cs_settings_automation_templates(inputs)
});